import React from "react";
import styled from "styled-components";

import Navbar from "../components/Navigation/Navbar/Navbar";
import { Container } from "./elements";
import Footer from "../pages/Footer/Footer";

const MainWrapper = styled.main`
  ${({ theme: { colors } }) => `
    width: 100%;
    overflow: hidden;
    background-color: ${colors.softGray};
  `}
`;

const Layout = ({ loggedIn, children }) => {
  return (
    <>
      <Navbar />
      <MainWrapper>
        <Container>{children}</Container>
      </MainWrapper>
      {!loggedIn && <Footer />}
    </>
  );
};

export default Layout;
